import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CampaignAnalyticsService {

  constructor(private route: ActivatedRoute) {}

  captureAndStoreParams(): void {
    this.route.queryParams.subscribe(params => {
      const storedParams = JSON.parse(localStorage.getItem('source') || '{}');
      const updatedParams = { ...storedParams, ...params };
      localStorage.setItem('source', JSON.stringify(updatedParams));
    });
  }

  getStoredParams(): { [key: string]: string } {
    return JSON.parse(localStorage.getItem('source') || '{}');
  }
}
